import { Skeleton } from 'components/common/skeleton';
import styled from 'types/theme.types';
import { BaseItemContainer, ItemText } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

const SKELETON_WIDTH = 60;
const SKELETON_HEIGHT = 14;

const StyledSkeletonInput = styled(Skeleton.Input)`
  width: ${SKELETON_WIDTH}px !important;
  height: ${SKELETON_HEIGHT}px !important;
`;

const NavbarMenuItemSkeleton = () => {
  const { isCollapsed } = useNavbarCollapse();
  return (
    <BaseItemContainer>
      <Skeleton.Avatar size="small" shape="square" active />
      {!isCollapsed && <ItemText>{!isCollapsed && <StyledSkeletonInput size="small" active />}</ItemText>}
    </BaseItemContainer>
  );
};

export default NavbarMenuItemSkeleton;
